import { render, staticRenderFns } from "./IconNotesWarning.vue?vue&type=template&id=68331287&"
import script from "./IconNotesWarning.vue?vue&type=script&lang=ts&"
export * from "./IconNotesWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports